"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require("babel-runtime/helpers/extends");

var _extends5 = _interopRequireDefault(_extends4);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkAttributeFn = function checkAttributeFn(jobs, checkFn) {
  return function (job, attribute) {
    return (job[attribute] || []).filter(function (otherSlug) {
      return checkFn(jobs[otherSlug], job);
    });
  };
};

var check = function check(jobs, attribute, checkFn) {
  var checkAttribute = checkAttributeFn(jobs, checkFn);
  return (0, _keys2.default)(jobs).reduce(function (obj, slug) {
    var job = jobs[slug];
    return (0, _extends5.default)({}, obj, (0, _defineProperty3.default)({}, slug, (0, _extends5.default)({}, job, (0, _defineProperty3.default)({}, attribute, checkAttribute(job, attribute)))));
  }, {});
};

exports.default = check;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/data/check/check.js
// module id = 448
// module chunks = 0